import axios from '@/libs/api.request'

// 获取折扣活动列表
export const GetDiscountList = data => {
  return axios.request({
    url: '/print/discount',
    params: data,
    method: 'get'
  })
}

// 获取折扣活动详情
export const GetDiscountInfo = data => {
  return axios.request({
    url: '/print/discount/info',
    params: data,
    method: 'get'
  })
}

// 保存折扣活动（新增或更新）
export const SaveDiscount = data => {
  return axios.request({
    url: '/print/discount',
    data,
    method: 'put'
  })
}

// 删除折扣活动
export const DeleteDiscount = data => {
  return axios.request({
    url: '/print/discount/del',
    data,
    method: 'post'
  })
}

// 恢复折扣活动
export const RestoreDiscount = data => {
  return axios.request({
    url: '/print/discount/restore',
    data,
    method: 'post'
  })
}

// 绑定设备到折扣活动
export const BindMachineDiscount = data => {
  return axios.request({
    url: '/print/discount/bind',
    data,
    method: 'post'
  })
}

// 解绑设备
export const UnbindMachineDiscount = data => {
  return axios.request({
    url: '/print/discount/unbind',
    data,
    method: 'post'
  })
}

// 根据折扣活动获取设备列表
export const GetMachinesByDiscount = data => {
  return axios.request({
    url: '/print/discount/machines',
    params: data,
    method: 'get'
  })
}
